export function getVisiblePages(
  current: number,
  total: number
): (number | "...")[] {
  if (total <= 0) return [];
  if (total <= 5) return Array.from({ length: total }, (_, i) => i + 1);

  const cur = Math.min(Math.max(current, 1), total);
  const pages: (number | "...")[] = [];

  pages.push(1);

  const start = Math.max(2, cur - 1);
  if (start > 2) pages.push("...");

  const end = Math.min(total - 1, cur + 1);
  for (let p = start; p <= end; p++) pages.push(p);
  if (end < total - 1) pages.push("...");
  pages.push(total);
  return pages;
}
